import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/StartPage.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/open-offers',
      name: 'open-offers',
      component: () => import('@/views/customer-support/OpenOffersPage.vue'),
      meta: {
        pageTitle: 'Open Offers',
        breadcrumb: [
          {
            text: 'Open Offers',
            active: true,
          },
        ],
      },
    },
    {
      path: '/top-customers',
      name: 'top-customers',
      component: () => import('@/views/customer-support/TopCustomers.vue'),
      meta: {
        pageTitle: 'Top Customers',
        breadcrumb: [
          {
            text: 'Top Customers',
            active: true,
          },
        ],
      },
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('@/views/customer-support/Products.vue'),
      meta: {
        pageTitle: 'Products',
        breadcrumb: [
          {
            text: 'Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/calculation-special-items',
      name: 'calculation-special-items',
      component: () => import('@/views/customer-support/CalculationSpecialItems.vue'),
      meta: {
        pageTitle: 'Calculation Special Items',
        breadcrumb: [
          {
            text: 'Calculation Special Items',
            active: true,
          },
        ],
      },
    },
    {
      path: '/conversion-rate',
      name: 'conversion-rate',
      component: () => import('@/views/customer-support/ConversionRate.vue'),
      meta: {
        pageTitle: 'Conversion Rate',
        breadcrumb: [
          {
            text: 'Conversion Rate',
            active: true,
          },
        ],
      },
    },
    {
      path: '/avg-delivery-time',
      name: 'avg-delivery-time',
      component: () => import('@/views/customer-support/AvgDeliveryTime.vue'),
      meta: {
        pageTitle: 'Avg Delivery Time',
        breadcrumb: [
          {
            text: 'Avg Delivery Time',
            active: true,
          },
        ],
      },
    },
    {
      path: '/phone-statistics',
      name: 'phone-statistics',
      component: () => import('@/views/customer-support/PhoneStatistics.vue'),
      meta: {
        pageTitle: 'Phone Statistics',
        breadcrumb: [
          {
            text: 'Phone Statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/email-statistics',
      name: 'email-statistics',
      component: () => import('@/views/customer-support/EmailStatistics.vue'),
      meta: {
        pageTitle: 'Email Statistics',
        breadcrumb: [
          {
            text: 'Email Statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/delivery-date-dashboard',
      name: 'delivery-date-dashboard',
      component: () => import('@/views/purchase-department/DeliveryDateDashboard.vue'),
      meta: {
        pageTitle: 'Delivery Date Dashboard',
        breadcrumb: [
          {
            text: 'Delivery Date Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/ppl-versand',
      name: 'ppl-shipments',
      component: () => import('@/views/purchase-department/PplShipments.vue'),
      meta: {
        pageTitle: 'PPL Versand',
        breadcrumb: [
          {
            text: 'PPL Versand',
            active: true,
          },
        ],
      },
    },
    {
      path: '/delayed-unconfirmed-orders',
      name: 'delayed-unconfirmed-orders',
      component: () => import('@/views/purchase-department/DelayedUnconfirmedOrders.vue'),
      meta: {
        pageTitle: 'Delayed/Unconfirmed Orders',
        breadcrumb: [
          {
            text: 'Delayed/Unconfirmed Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/open-suppliers-orders',
      name: 'open-suppliers-orders',
      component: () => import('@/views/purchase-department/OpenSuppliersOrders.vue'),
      meta: {
        pageTitle: 'Open Suppliers Orders',
        breadcrumb: [
          {
            text: 'Open Suppliers Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/a-products',
      name: 'a-products',
      component: () => import('@/views/purchase-department/AProducts.vue'),
      meta: {
        pageTitle: 'A-Products',
        breadcrumb: [
          {
            text: 'A-Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/purchase-recommendations',
      name: 'purchase-recommendations',
      component: () => import('@/views/purchase-department/PurchaseRecommendations.vue'),
      meta: {
        pageTitle: 'Purchase Recommendations',
        breadcrumb: [
          {
            text: 'Purchase Recommendations',
            active: true,
          },
        ],
      },
    },
    {
      path: '/purchase-negotiation-opportunities',
      name: 'purchase-negotiation-opportunities',
      component: () => import('@/views/purchase-department/PurchaseNegotiationOpportunities.vue'),
      meta: {
        pageTitle: 'Negotiation Opportunities',
        breadcrumb: [
          {
            text: 'Negotiation Opportunities',
            active: true,
          },
        ],
      },
    },
    {
      path: '/purchase-approvals',
      name: 'purchase-approvals',
      component: () => import('@/views/purchase-department/PurchaseApprovals.vue'),
      meta: {
        pageTitle: 'Purchase Approvals',
        breadcrumb: [
          {
            text: 'Purchase Approvals',
            active: true,
          },
        ],
      },
    },
    {
      path: '/purchase-approvals/:id',
      name: 'purchase-approval-detail',
      component: () => import('@/views/purchase-department/PurchaseApprovals.vue'),
      meta: {
        pageTitle: 'Purchase Approvals',
        breadcrumb: [
          { text: 'Purchase Approvals', to: '/purchase-approvals' },
          { text: 'Detail', active: true },
        ],
      },
    },
    {
      path: '/purchase-order-frequency',
      name: 'purchase-order-frequency',
      component: () => import('@/views/purchase-department/PurchaseOrderFrequency.vue'),
      meta: {
        pageTitle: 'Purchase Order Frequency',
        breadcrumb: [
          {
            text: 'Purchase Order Frequency',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cross-selling-alternative-products',
      name: 'cross-selling-alternative-products',
      component: () => import('@/views/purchase-department/CrossSellingAlternativeProducts.vue'),
      meta: {
        pageTitle: 'Alternatives/Cross Selling Products',
        breadcrumb: [
          {
            text: 'Alternatives/Cross Selling Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/suppliers-statistics',
      name: 'suppliers-statistics',
      component: () => import('@/views/purchase-department/SuppliersStatistics.vue'),
      meta: {
        pageTitle: 'Suppliers Statistics',
        breadcrumb: [
          {
            text: 'Suppliers Statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/price-adjustments',
      name: 'price-adjustments',
      beforeEnter() {
        window.open('https://docs.google.com/spreadsheets/d/1hat8Le2O6lBH4hgN2nA529-JOjugEAAXoEiItik9Kas/edit?gid=1727390691#gid=1727390691', '_blank')
      },
    },
    {
      path: '/category-development',
      name: 'category-development',
      component: () => import('@/views/product-management/CategoryDevelopment.vue'),
      meta: {
        pageTitle: 'Category Development',
        breadcrumb: [
          {
            text: 'Category Development',
            active: true,
          },
        ],
      },
    },
    {
      path: '/category-statistics',
      name: 'category-statistics',
      component: () => import('@/views/product-management/CategoryStatistics.vue'),
      meta: {
        pageTitle: 'Category Statistics',
        breadcrumb: [
          {
            text: 'Category Statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/brands-statistics',
      name: 'brands-statistics',
      component: () => import('@/views/product-management/BrandsStatistics.vue'),
      meta: {
        pageTitle: 'Brands Statistics',
        breadcrumb: [
          {
            text: 'Brands Statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product-sales-statistics',
      name: 'product-sales-statistics',
      component: () => import('@/views/product-management/ProductSalesStatistics.vue'),
      meta: {
        pageTitle: 'Product Sales Statistics',
        breadcrumb: [
          {
            text: 'Product Sales Statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product-abc',
      name: 'product-abc',
      component: () => import('@/views/product-management/ProductABC.vue'),
      meta: {
        pageTitle: 'Product ABC Analysis',
        breadcrumb: [
          {
            text: 'Product ABC Analysis',
            active: true,
          },
        ],
      },
    },
    {
      path: '/marketplace-readiness-score',
      name: 'marketplace-readiness-score',
      component: () => import('@/views/product-management/MarketplaceReadinessScore.vue'),
      meta: {
        pageTitle: 'Marketplace Readiness Score',
        breadcrumb: [
          {
            text: 'Marketplace Readiness Score',
            active: true,
          },
        ],
      },
    },
    {
      path: '/updated-status-products',
      name: 'updated-status-products',
      component: () => import('@/views/product-management/UpdatedStatusProducts.vue'),
      meta: {
        pageTitle: 'Updated Status Products',
        breadcrumb: [
          {
            text: 'Updated Status Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/fast-slowmover-products',
      name: 'fast-slowmover-products',
      component: () => import('@/views/product-management/FastSlowmoverProducts.vue'),
      meta: {
        pageTitle: 'Fast/Slowmover Products',
        breadcrumb: [
          {
            text: 'Fast/Slowmover Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/not-sold-products',
      name: 'not-sold-products',
      component: () => import('@/views/product-management/NotSoldProducts.vue'),
      meta: {
        pageTitle: 'Not Sold Products',
        breadcrumb: [
          {
            text: 'Not Sold Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/active-inactive-products',
      name: 'active-inactive-products',
      component: () => import('@/views/product-management/ActiveInactiveProducts.vue'),
      meta: {
        pageTitle: 'Active/Inactive Products',
        breadcrumb: [
          {
            text: 'Active/Inactive Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/outdated-products',
      name: 'outdated-products',
      component: () => import('@/views/product-management/OutdatedProducts.vue'),
      meta: {
        pageTitle: 'Outdated Products',
        breadcrumb: [
          {
            text: 'Outdated Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/dropshipping',
      name: 'dropshipping',
      component: () => import('@/views/product-management/Dropshipping.vue'),
      meta: {
        pageTitle: 'Dropshipping',
        breadcrumb: [
          {
            text: 'Dropshipping',
            active: true,
          },
        ],
      },
    },
    {
      path: '/products-attributes',
      name: 'products-attributes',
      component: () => import('@/views/product-management/ProductsAttributes.vue'),
      meta: {
        pageTitle: 'Products Attributes',
        breadcrumb: [
          {
            text: 'Products Attributes',
            active: true,
          },
        ],
      },
    },
    {
      path: '/new-articles-hh',
      name: 'new-articles-hh',
      beforeEnter() {
        window.open('https://docs.google.com/spreadsheets/d/1R1CPUy0VqdAxI8mKHkvFvnklQO3hPrxrztE9utVqWxg/edit#gid=0', '_blank')
      },
    },
    {
      path: '/all-scraped-items',
      name: 'all-scraped-items',
      beforeEnter() {
        window.open('https://docs.google.com/spreadsheets/d/10knGlv8zimiRj0OVdZ5pbvhF3EuA-NFn8Hqt7CwCcNE/edit#gid=245173986', '_blank')
      },
    },
    {
      path: '/product-data-review',
      name: 'product-data-review',
      component: () => import('@/views/product-management/product-data/ProductDataReview.vue'),
      meta: {
        pageTitle: 'Product Data Review',
        breadcrumb: [
          {
            text: 'Product Data Review',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product-data-progress',
      name: 'product-data-progress',
      component: () => import('@/views/product-management/product-data/ProductDataProgress.vue'),
      meta: {
        pageTitle: 'Product Data Progress',
        breadcrumb: [
          {
            text: 'Product Data Progress',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product-data-pipeline',
      name: 'product-data-pipeline',
      component: () => import('@/views/product-management/product-data/ProductDataPipeline.vue'),
      meta: {
        pageTitle: 'Product Data Pipeline',
        breadcrumb: [
          {
            text: 'Product Data Pipeline',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product-data-knowledge',
      name: 'product-data-knowledge',
      component: () => import('@/views/product-management/product-data/ProductDataKnowledge.vue'),
      meta: {
        pageTitle: 'Product Data Knowledge',
        breadcrumb: [
          {
            text: 'Product Data Knowledge',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pricing-tool',
      name: 'pricing-tool',
      beforeEnter() {
        window.open('https://docs.google.com/spreadsheets/d/1n9bsm6MyAq5fHj8nJ31gbe9uWZEUCAYuGfLVtZ6s7QY/edit#gid=1348256019', '_blank')
      },
    },
    {
      path: '/order-intelligence',
      name: 'order-intelligence',
      component: () => import('@/views/intelligence/OrderIntelligenceCockpit.vue'),
      meta: {
        pageTitle: 'Order Intelligence',
        breadcrumb: [
          {
            text: 'Order Intelligence',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product-intelligence',
      name: 'product-intelligence',
      component: () => import('@/views/intelligence/ProductIntelligenceCockpit.vue'),
      meta: {
        pageTitle: 'Product Intelligence',
        breadcrumb: [
          {
            text: 'Product Intelligence',
            active: true,
          },
        ],
      },
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('@/views/controlling/Finance.vue'),
      meta: {
        pageTitle: 'Finance',
        breadcrumb: [
          {
            text: 'Finance',
            active: true,
          },
        ],
      },
    },
    {
      path: '/staff-cost-comparison',
      name: 'staff-cost-comparison',
      component: () => import('@/views/controlling/StaffCostComparison.vue'),
      meta: {
        pageTitle: 'Personalkosten-Abgleich',
        breadcrumb: [
          {
            text: 'Personalkosten-Abgleich',
            active: true,
          },
        ],
      },
    },
    {
      path: '/monthly-staff-overview',
      name: 'staff-hours-overview',
      component: () => import('@/views/controlling/StaffHoursOverview.vue'),
      meta: {
        pageTitle: 'Monthly Staff Overview',
        breadcrumb: [
          {
            text: 'Monthly Staff Overview',
            active: true,
          },
        ],
      },
    },
    {
      path: '/finance-report',
      name: 'finance-report',
      component: () => import('@/views/controlling/FinanceReport.vue'),
      meta: {
        pageTitle: 'Finance Report',
        breadcrumb: [
          {
            text: 'Finance Report',
            active: true,
          },
        ],
      },
    },
    {
      path: '/aufgaben',
      name: 'tasks',
      component: () => import('@/views/tasks/TasksPage.vue'),
      meta: {
        pageTitle: 'Aufgaben',
        breadcrumb: [
          {
            text: 'Aufgaben',
            active: true,
          },
        ],
      },
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: () => import('@/views/controlling/Marketing.vue'),
      meta: {
        pageTitle: 'Marketing',
        breadcrumb: [
          {
            text: 'Marketing',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('@/views/controlling/Analytics.vue'),
      meta: {
        pageTitle: 'Analytics',
        breadcrumb: [
          {
            text: 'Analytics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/orders-analytics',
      name: 'orders-analytics',
      component: () => import('@/views/controlling/OrdersAnalytics.vue'),
      meta: {
        pageTitle: 'Orders Analytics',
        breadcrumb: [
          {
            text: 'Orders Analytics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/month-report',
      name: 'month-report',
      component: () => import('@/views/controlling/MonthReport.vue'),
      meta: {
        pageTitle: 'Month Report',
        breadcrumb: [
          {
            text: 'Month Report',
            active: true,
          },
        ],
      },
    },
    {
      path: '/stock-value',
      name: 'stock-value',
      component: () => import('@/views/controlling/StockValue.vue'),
      meta: {
        pageTitle: 'Stock Value',
        breadcrumb: [
          {
            text: 'Stock Value',
            active: true,
          },
        ],
      },
    },
    {
      path: '/liquidity',
      name: 'liquidity',
      component: () => import('@/views/controlling/Liquidity.vue'),
      meta: {
        pageTitle: 'Liquidity',
        breadcrumb: [
          {
            text: 'Liquidity',
            active: true,
          },
        ],
      },
    },
    {
      path: '/revenue-margin',
      name: 'revenue-margin',
      component: () => import('@/views/controlling/RevenueMargin.vue'),
      meta: {
        pageTitle: 'Revenue Margin',
        breadcrumb: [
          {
            text: 'Revenue Margin',
            active: true,
          },
        ],
      },
    },
    {
      path: '/price-calculation',
      name: 'price-calculation',
      component: () => import('@/views/controlling/PriceCalculation.vue'),
      meta: {
        pageTitle: 'Price Calculation',
        breadcrumb: [
          {
            text: 'Price Calculation',
            active: true,
          },
        ],
      },
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/controlling/Orders.vue'),
      meta: {
        pageTitle: 'Orders',
        breadcrumb: [
          {
            text: 'Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/freight-charges',
      name: 'freight-charges',
      component: () => import('@/views/controlling/FreightCharges.vue'),
      meta: {
        pageTitle: 'Freight Charges',
        breadcrumb: [
          {
            text: 'Freight Charges',
            active: true,
          },
        ],
      },
    },
    {
      path: '/warehouse-statistics',
      name: 'warehouse-statistics',
      component: () => import('@/views/controlling/WarehouseStatistics.vue'),
      meta: {
        pageTitle: 'Warehouse Statistics',
        breadcrumb: [
          {
            text: 'Warehouse Statistics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/suppliers-orders',
      name: 'suppliers-orders',
      component: () => import('@/views/controlling/SuppliersOrders.vue'),
      meta: {
        pageTitle: 'Suppliers Orders',
        breadcrumb: [
          {
            text: 'Suppliers Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bookkeeping',
      name: 'bookkeeping',
      component: () => import('@/views/controlling/Bookkeeping.vue'),
      meta: {
        pageTitle: 'Bookkeeping',
        breadcrumb: [
          {
            text: 'Bookkeeping',
            active: true,
          },
        ],
      },
    },
    {
      path: '/invoices-gmi',
      name: 'invoices-gmi',
      component: () => import('@/views/controlling/GMI.vue'),
      meta: {
        pageTitle: 'GMI',
        breadcrumb: [
          {
            text: 'GMI',
            active: true,
          },
        ],
      },
    },
    {
      path: '/plan-numbers',
      name: 'plan-numbers',
      component: () => import('@/views/controlling/PlanNumbers.vue'),
      meta: {
        pageTitle: 'Plan Numbers',
        breadcrumb: [
          {
            text: 'Plan Numbers',
            active: true,
          },
        ],
      },
    },
    {
      path: '/payment-settings',
      name: 'payment-settings',
      component: () => import('@/views/controlling/PaymentSettings.vue'),
      meta: {
        pageTitle: 'Payment Settings',
        breadcrumb: [
          {
            text: 'Payment Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/performance-overview',
      name: 'performance-overview',
      component: () => import('@/views/controlling/PerformanceOverview.vue'),
      meta: {
        pageTitle: 'Performance Overview',
        breadcrumb: [
          {
            text: 'Performance Overview',
            active: true,
          },
        ],
      },
    },
    {
      path: '/phone-report',
      name: 'phone-report',
      component: () => import('@/views/controlling/PhoneReport.vue'),
      meta: {
        pageTitle: 'Phone Report',
        breadcrumb: [
          {
            text: 'Phone Report',
            active: true,
          },
        ],
      },
    },
    {
      path: '/email-report',
      name: 'email-report',
      component: () => import('@/views/controlling/EmailReport.vue'),
      meta: {
        pageTitle: 'Email Report',
        breadcrumb: [
          {
            text: 'Email Report',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vacation-sickday-overview',
      name: 'vacation-sickday-overview',
      component: () => import('@/views/controlling/VacationSickdayOverview.vue'),
      meta: {
        pageTitle: 'Vacation/Sickday Overview',
        breadcrumb: [
          {
            text: 'Vacation/Sickday Overview',
            active: true,
          },
        ],
      },
    },
    {
      path: '/ai',
      name: 'ai',
      component: () => import('@/views/ai/AI.vue'),
      meta: {
        pageTitle: 'AI',
        breadcrumb: [
          {
            text: 'AI',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user-management',
      name: 'user-management',
      component: () => import('@/views/users/UserManagement.vue'),
      meta: {
        pageTitle: 'User Management',
        breadcrumb: [
          {
            text: 'User Management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vacation-tracking',
      name: 'vacation-tracking',
      component: () => import('@/views/VacationTracking.vue'),
      meta: {
        pageTitle: 'Vacation Tracking',
        breadcrumb: [
          {
            text: 'Vacation Tracking',
            active: true,
          },
        ],
      },
    },
    // Sales CRM Routes
    {
      path: '/customers-analytics',
      name: 'customers-analytics',
      component: () => import('@/views/sales/CustomersAnalytics.vue'),
      meta: {
        pageTitle: 'Customers Analytics',
        breadcrumb: [
          {
            text: 'Customers Analytics',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sales-board',
      name: 'sales-board',
      component: () => import('@/views/sales/SalesBoardPage.vue'),
      meta: {
        pageTitle: 'Sales Board',
        breadcrumb: [
          {
            text: 'Sales Board',
            active: true,
          },
        ],
      },
    },
    {
      path: '/my-leads',
      name: 'my-leads',
      component: () => import('@/views/sales/MyLeads.vue'),
      meta: {
        pageTitle: 'My Leads',
        breadcrumb: [
          {
            text: 'My Leads',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sales-dashboard',
      name: 'sales-dashboard',
      component: () => import('@/views/sales/SalesDashboard.vue'),
      meta: {
        pageTitle: 'Sales Dashboard',
        breadcrumb: [
          {
            text: 'Sales Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sales-activities',
      name: 'sales-activities',
      component: () => import('@/views/sales/SalesActivities.vue'),
      meta: {
        pageTitle: 'Sales Activities',
        breadcrumb: [
          {
            text: 'Sales Activities',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sales-reminders',
      name: 'sales-reminders',
      component: () => import('@/views/sales/SalesReminders.vue'),
      meta: {
        pageTitle: 'Sales Reminders',
        breadcrumb: [
          {
            text: 'Sales Reminders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/performance',
      name: 'performance',
      component: () => import('@/views/sales/GamificationDashboard.vue'),
      meta: {
        pageTitle: 'Performance',
        breadcrumb: [
          {
            text: 'Performance',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/password-reset-done',
      name: 'password-reset-done',
      component: () => import('@/views/PasswordResetDone.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: () => import('@/views/PasswordReset.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/password-reset-complete',
      name: 'password-reset-complete',
      component: () => import('@/views/PasswordResetComplete.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
